<template>
    <main-content>
        <div class="shadow-sm rounded p-4">
            <settlement-form :form_data="form_data"
                             :form_meta_data="form_meta_data"
                             :on_submit="settlement"
            >
            </settlement-form>
        </div>
    </main-content>
</template>

<script>
    import SettlementForm from './components/settlement-form'
    import mainContent from '@/components/main-content'
    import {i18n} from "@/plugins/i18n";
    import $ from "jquery";
    import {walletService} from "@/common/api.service";
    import {withdrawType} from "@/constants/withdrawType";

    export default {
        components: {
            SettlementForm,
            mainContent,
        },
        data() {
            return {
                withdrawType,
                form_data: {
                    withdraw_type: null,

                    internal_destination_deposit: '',
                    internal_amount: '',

                    internal_group_destination_batch_transfers: [
                        {
                            destination_deposit_number: '',
                            amount: '',
                        },
                        {
                            destination_deposit_number: '',
                            amount: '',
                        },
                    ],

                    paya_group_transactions: [
                        {
                            iban_number: '',
                            owner_name: '',
                            amount: '',
                        },
                        {
                            iban_number: '',
                            owner_name: '',
                            amount: '',
                        },
                    ],

                    satna_group_transactions: [
                        {
                            iban: '',
                            receiver_name: '',
                            receiver_family: '',
                            amount: '',
                        },
                        {
                            iban: '',
                            receiver_name: '',
                            receiver_family: '',
                            amount: '',
                        },
                    ],
                },
                form_meta_data: {
                    submit_btn_progress: false,
                    submit_btn_text: i18n.t('wallets.label.settlement'),
                },
            };
        },
        methods: {
            settlement() {
                let form = $('#submit_form');

                form.validate({
                    rules: {
                        withdraw_type: {
                            required: true,
                        },

                        internal_destination_deposit: {
                            required: () => {
                                return (this.form_data.withdraw_type === this.withdrawType.INTERNAL);
                            },
                        },
                        internal_amount: {
                            required: () => {
                                return (this.form_data.withdraw_type === this.withdrawType.INTERNAL);
                            },
                        },

                        paya_iban_number: {
                            required: () => {
                                return (this.form_data.withdraw_type === this.withdrawType.PAYA);
                            },
                        },
                        paya_owner_name: {
                            required: () => {
                                return (this.form_data.withdraw_type === this.withdrawType.PAYA);
                            },
                        },
                        paya_amount: {
                            required: () => {
                                return (this.form_data.withdraw_type === this.withdrawType.PAYA);
                            },
                        },

                        satna_destination_iban_number: {
                            required: () => {
                                return (this.form_data.withdraw_type === this.withdrawType.SATNA);
                            },
                        },
                        satna_receiver_name: {
                            required: () => {
                                return (this.form_data.withdraw_type === this.withdrawType.SATNA);
                            },
                        },
                        satna_receiver_family: {
                            required: () => {
                                return (this.form_data.withdraw_type === this.withdrawType.SATNA);
                            },
                        },
                        satna_amount: {
                            required: () => {
                                return (this.form_data.withdraw_type === this.withdrawType.SATNA);
                            },
                            min: 150000000,
                        },
                    },
                });

                if (! form.valid()) {
                    return;
                }

                this.form_meta_data.submit_btn_progress = true;

                let params = {
                    withdraw_type: this.form_data.withdraw_type,

                    internal_destination_deposit: this.form_data.internal_destination_deposit,
                    internal_amount: this.form_data.internal_amount,

                    internal_group_destination_batch_transfers: this.form_data.internal_group_destination_batch_transfers,

                    paya_iban_number: this.form_data.paya_iban_number,
                    paya_owner_name: this.form_data.paya_owner_name,
                    paya_amount: this.form_data.paya_amount,

                    paya_group_transactions: this.form_data.paya_group_transactions,

                    satna_destination_iban_number: this.form_data.satna_destination_iban_number,
                    satna_receiver_name: this.form_data.satna_receiver_name,
                    satna_receiver_family: this.form_data.satna_receiver_family,
                    satna_amount: this.form_data.satna_amount,

                    satna_group_transactions: this.form_data.satna_group_transactions,
                };

                walletService.settlementDay(params, this.$route.params.hashid).then(response => {
                    this.$router.push('/day-wallets');
                }).catch(({response}) => {
                    if (response.data) {
                        form.validate().showErrors(response.data.data);
                    }

                    this.showMsg(form, 'danger', response.data.message);
                }).finally(() => {
                    this.form_meta_data.submit_btn_progress = false;
                });
            },
        },
    }
</script>
